<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/shop-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">门店全场景IOT解决方案</div>
      </div>
      <img src="@/assets/Mobile/images/solution/manage01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">门店多场景收银解决方案</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="left">
            <span class="title">零售小店解决方案</span>
            <ul>
              <li>
                <div /><span>收银记账</span>
              </li>
              <li>
                <div /><span>库存管理</span>
              </li>
              <li>
                <div /><span>促销活动</span>
              </li>
              <li>
                <div /><span>报表分析</span>
              </li>
            </ul>
          </div>
          <img class="image01" src="@/assets/Mobile/images/solution/manage02.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <span class="title">水果生鲜解决方案</span>
            <ul>
              <li>
                <div /><span>称重收银</span>
              </li>
              <li>
                <div /><span>会员营销</span>
              </li>
              <li>
                <div /><span>称重码打印</span>
              </li>
              <li>
                <div /><span>数据报表</span>
              </li>
            </ul>
          </div>
          <img class="image01" src="@/assets/Mobile/images/solution/manage03.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <span class="title">3C数码解决方案</span>
            <ul>
              <li>
                <div /><span>串码管理</span>
              </li>
              <li>
                <div /><span>收银记账</span>
              </li>
              <li>
                <div /><span>移动盘点</span>
              </li>
              <li>
                <div /><span>促销活动</span>
              </li>
            </ul>
          </div>
          <img class="image01" src="@/assets/Mobile/images/solution/manage04.png" alt="">
        </div>
        <div class="item">
          <div class="left">
            <span class="title">自助收银解决方案</span>
            <ul>
              <li>
                <div /><span>AI识客监控</span>
              </li>
              <li>
                <div /><span>自助结算收银</span>
              </li>
              <li>
                <div /><span>商品电子标签</span>
              </li>
              <li>
                <div /><span>缺货自动预警</span>
              </li>
            </ul>
          </div>
          <img class="image01" src="@/assets/Mobile/images/solution/manage05.png" alt="">
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">让门店收银更简单、快捷</div>
      </div>
      <img src="@/assets/Mobile/images/solution/manage06.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">产品介绍</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/manage07.png" alt="">
          <span class="title">界面风格</span>
          <div class="line" />
          <span class="text">界面简洁、清晰明了、重点突出</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/manage08.png" alt="">
          <span class="title">操作交互</span>
          <div class="line" />
          <span class="text">操作简单流畅、减少培训、任何操作3步内完成</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/manage09.png" alt="">
          <span class="title">产品功能</span>
          <div class="line" />
          <span class="text">尽量避免让用户提前维护基础数据、做到开机即用</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/manage10.png" alt="">
          <span class="title">专机专用</span>
          <div class="line" />
          <span class="text">专注进销存和经营管理</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/manage11.png" alt="">
          <span class="title">搭配硬件</span>
          <div class="line" />
          <span class="text">扫码枪、扫码盒子、打印机、POS机、钱箱</span>
        </div>
      </div>
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">定制流程</div>
      </div>
      <img src="@/assets/Mobile/images/solution/brand02.png" alt="">
    </div>
    <Case title="门店管理定制" />
    <ContactForm info-sources="门店管理定制" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import Case from '@/Mobile/Mobilecom/Case'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'

export default {
  metaInfo: metaInfo.ShopCustom,
  components: {
    Case,
    ContactForm
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 337px;
    margin: 21px 0 18px 0;
  }
}
.block02 {
  background-color: #F6FBFF;
  overflow: hidden;
  .content {
    padding-top: 15px;
    .item {
      width: 343px;
      height: 175px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      background: #FFFFFF;
      padding-top: 23px;
      margin: 0 auto 10px auto;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
      }
      .left {
        width: 112px;
        ul {
          margin-top: 17px;
        }
        li {
          text-align: left;
          margin-bottom: 4px;
          &>div {
            display: inline-block;
            width: 11px;
            height: 11px;
            background: url("~@/assets/Mobile/images/solution/manage-icon-check.png") no-repeat;
            background-size: 100%;
          }
        }
      }
      .image01 {
        width: 149px;
      }
    }
  }
}
.block03 {
  img {
    width: 336px;
    margin: 19px 0 26px 0;
  }
}
.block04 {
  background-color: #F9F9F9;
  .content {
    padding: 10px;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: center;
      width: 96px;
      margin: 11px;
      .title {
        margin-top: 9px;
        font-size: 10px;
        font-weight: 500;
        color: #595961;
        line-height: 14px;
      }
      .line {
        margin-top: 6px;
        width: 16px;
        height: 2px;
        background: #3986FF;
      }
      .text {
        margin-top: 6px;
        font-size: 8px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 11px;
      }
      img {
        width: 59px;
      }
    }
  }
}
.block05 {
  img {
    margin: 16px 0 24px 0;
    width: 341px;
  }
}
</style>
